export const rejectVehicleValidation = {
  reason: [{ required: true, message: 'Reason is required!' }],
  otherReason: [{ required: true, whitespace: true, message: 'Description is required!' }],
};
